import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import tr from "@/locales/tr/translation.json";
import en from "@/locales/en/translation.json";
import id from "@/locales/id/translation.json";

// Central i18n config. Bootstrapped once at app start (see src/index.js).
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
      id: { translation: id },
    },
    fallbackLng: "tr",
    supportedLngs: ["tr", "en", "id"],
    interpolation: { escapeValue: false },
    // The key `x.y.z` is a flat string in our JSON files, NOT a nested path
    keySeparator: false,
    nsSeparator: false,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export const SUPPORTED_LANGS = [
  { code: "tr", label: "Türkçe", short: "TR" },
  { code: "en", label: "English", short: "EN" },
  { code: "id", label: "Bahasa Indonesia", short: "ID" },
];

export default i18n;
